import { render, staticRenderFns } from "./ConsigneeInfo.vue?vue&type=template&id=34ec6bc2&"
import script from "./ConsigneeInfo.vue?vue&type=script&lang=js&"
export * from "./ConsigneeInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConsigneeInfo.vue?vue&type=style&index=0&id=34ec6bc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports